export default [{
  'icon': 'bobcaticon-asset',
  'title': 'My Machine',
  'path': '/service/mymachine'
},
{
  'icon': 'book',
  'title': 'Service Library',
  'path': '/service/library'
}]
